<template>
  <footer class="footer">
    <router-link to="/index">
      <ui-icon name="icon-copyright"></ui-icon>{{ $t("unicapsule") }}
    </router-link>
    - 2017-2018 - <span v-if="icp">{{ icp }}</span>
    <div class="navbar">
      <!--       <span @click="feedback">Feedback</span>
      <a href="#site-article/privacy-policy">Privacy</a> -->
      <lang-selector v-if="i18n"></lang-selector>
    </div>
  </footer>
</template>
<script>
import { mapGetters } from "vuex";
import LangSelector from "./LangSelector.vue";
import config from "../config.js";
const siteConfig = config[process.env.NODE_ENV];
export default {
  data() {
    return {
      i18n: siteConfig.i18n,
      icp: siteConfig.icp
    };
  },
  components: {
    LangSelector
  },
  computed: {
    ...mapGetters(["authInfo"])
  },
  methods: {
    feedback() {
      this.$UiModal({
        title: "没有人爱你"
      });
    }
  }
};
</script>
